import { widget } from "@foretagsplatsen/widgetjs";

/**
 * A `sectionWidget` renders a section, possibly with a title, css class
 * and/or id.
 *
 * The content of the section is displayed as a full row, and as such
 * sections should not be nested.
 *
 * @param {{}} spec - Parameter object
 * @param {Renderable} [spec.title] - Title of the section, rendered inside an <H2> tag.
 * @param {string} [spec.titleCssClass] - Classes used for the section title.
 * @param {string} [spec.cssClass] - Classes used for the section.
 * @param {string} [spec.cssId] - Id used for the section.
 * @param {string} [spec.dataHelpName] - String used by the help system to find the section.
 * @param {Renderable} spec.content - Content rendered within the section.
 * @param {{}} my - protected fields holder
 * @return {*} sectionWidget
 */
function sectionWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.title = spec.title;
	my.cssClass = spec.cssClass || "";
	my.titleCssClass = spec.titleCssClass || "";
	my.cssId = spec.cssId || "";
	my.content = spec.content;
	my.dataTestName = spec.dataTestName || "";
	my.dataHelpName = spec.dataHelpName || "";

	that.renderContentOn = function (html) {
		html.div(
			{
				klass: [my.cssClass, "section"],
				id: my.cssId,
				"data-test": my.dataTestName,
				"data-help": my.dataHelpName,
			},
			html.div(
				{ klass: "col-md-12 section-row" },
				my.renderTitleOn,
				my.content,
			),
		);
	};

	my.renderTitleOn = function (html) {
		if (!my.title) {
			return;
		}

		html.h2(
			{
				klass: my.titleCssClass,
			},
			my.title,
		);
	};

	return that;
}

export default sectionWidget;
